import { Heading } from '@cinch-labs/design-system'
import { getDayMonthYearFormat } from '@cinch-labs/shared-util'
import { StoryblokImage } from '@cinch-nx/data-storyblok'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import cx from 'classnames'
import Image from 'next/legacy/image'
import Link from 'next/link'

import styles from './article-preview-card.module.css'

export interface ArticlePreviewCardProps {
  image: StoryblokImage
  title: string
  date: string
  path: string
  featured?: boolean
}

export const ArticlePreviewCard: React.FC<ArticlePreviewCardProps> = ({
  image,
  date,
  title,
  path,
  featured,
}) => {
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    trackEvent({
      eventName: `Guides - click article card`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'link',
          label: title,
          action: EventNames.click,
        },
      },
    })
  }

  return (
    <li
      className={cx(styles['container'], {
        [styles['featuredContainer']]: featured,
      })}
      data-testid="article-preview-card"
    >
      <Link href={path} passHref legacyBehavior>
        <a
          href="/guides"
          aria-label={title}
          className={styles['listItem']}
          onClick={handleClick}
        >
          <div
            className={cx(styles['imageContainer'], {
              [styles['featuredImageContainer']]: featured,
            })}
          >
            <Image
              className={styles['image']}
              alt={image?.alt || ''}
              src={
                image?.filename ||
                `${
                  process.env['STAGE_NAME'] ?? 'local'
                    ? ''
                    : process.env['STAGE_URL']
                }/image-coming-soon.svg`
              }
              layout="responsive"
              width={featured ? 345 : 110}
              height={featured ? 220 : 70}
              priority={featured}
            />
          </div>
          <div
            className={cx(styles['content'], {
              [styles['featuredContent']]: featured,
            })}
          >
            <Heading element="h3" className={styles['title']}>
              {title}
            </Heading>
            <time dateTime={date} className={styles['date']}>
              {getDayMonthYearFormat(date)}
            </time>
          </div>
        </a>
      </Link>
    </li>
  )
}
